// Styled components.
import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  font-family: Arial, sans-serif;
  color: #ded9e0;
  
.App {
  display: flex;
  flex-direction: column;
  height: 100vh;

  padding: 0;
  margin: 0;
}

`;
